import styled from 'styled-components'

export const H3 = styled.h3`
  font-size: 1.125em;
  line-height: 1.25em;
  color: ${({ theme }) => theme.darkGrey};
  font-weight: normal;
`
